import { render, staticRenderFns } from "./role-list-page.vue?vue&type=template&id=04246740&scoped=true"
import script from "./role-list-page.vue?vue&type=script&lang=js"
export * from "./role-list-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04246740",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04246740')) {
      api.createRecord('04246740', component.options)
    } else {
      api.reload('04246740', component.options)
    }
    module.hot.accept("./role-list-page.vue?vue&type=template&id=04246740&scoped=true", function () {
      api.rerender('04246740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/system-management/project-management/role-list-page.vue"
export default component.exports